import '../globalLibrariesMinimal';

import ReactComponentMounter from '../utils/react-component-mounter';

/**
 * This pack only registers components that are applicable to the main (root)
 * landing page (/).
 * */
import LandingPageRouter from '../apps/LandingPage';
import Microfrontend from '../apps/Microfrontend';

ReactComponentMounter.register({
  LandingPageRouter,
  Microfrontend
});
